export default __webpack_public_path__ + "static/media/maure_de_bretagne11.0b804cbc.jpg";